import { render, staticRenderFns } from "./message-box.vue?vue&type=template&id=df4edd92&scoped=true&"
import script from "./message-box.vue?vue&type=script&lang=js&"
export * from "./message-box.vue?vue&type=script&lang=js&"
import style0 from "./message-box.vue?vue&type=style&index=0&id=df4edd92&lang=sass&scoped=true&"
import style1 from "./message-box.vue?vue&type=style&index=1&id=df4edd92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4edd92",
  null
  
)

export default component.exports